import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "./trainerPortal.css";

export default function TrainerCertification() {
  const [certifications, setCertifications] = useState([]);
  const [certificationName, setCertificationName] = useState("");
  const [issueAuthority, setIssueAuthority] = useState("");
  const [issueDate, setIssueDate] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [certificationPath, setCertificationPath] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const fetchCertifications = async () => {
      try {
        const response = await AxiosInstance.get(
          "companies/certifications/"
        );
        setCertifications(response.data);
      } catch (error) {
        console.error("Error fetching certifications:", error);
        setErrorMessage("Failed to fetch certifications.");
      }
    };
    fetchCertifications();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const trainerId = localStorage.getItem("trainerId");
    if (!trainerId) {
      alert("Trainer not logged in.");
      setIsLoading(false);
      return;
    }
    const newCertification = {
      trainer: trainerId,
      certification: certificationName,
      issue_authority: issueAuthority,
      issue_date: issueDate,
      expiry_date: expiryDate || null,
      certificate_path: certificationPath,
    };

    try {
      const response = await AxiosInstance.post(
        "companies/user/certifications/",
        newCertification
      );

      if (response.status === 201) {
        navigate(-1);
      } else {
        setErrorMessage("Failed to save certification.");
      }
    } catch (error) {
      console.error("Error creating certification:", error);
      setErrorMessage("Something went wrong. Please try again.");
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <>
      <div
        className="modal d-block als-trainer-portal"
        tabIndex="-1"
        style={{ backgroundColor: "rgba(11,14,39,0.45)" }}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Certification</h5>
            </div>

            <div className="modal-body">
              {errorMessage && (
                <div className="alert alert-danger">{errorMessage}</div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Certification Name</label>
                  <select
                    className="form-select"
                    value={certificationName}
                    onChange={(e) => setCertificationName(e.target.value)}
                    required
                  >
                    <option value="">Select Certification</option>
                    {certifications.map((cert) => (
                      <option
                        key={cert.certification_id}
                        value={cert.certification_id}
                      >
                        {cert.certification_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Issuing Authority</label>
                  <input
                    type="text"
                    className="form-control"
                    value={issueAuthority}
                    onChange={(e) => setIssueAuthority(e.target.value)}
                    required
                  />
                </div>

                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Issue Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={issueDate}
                      onChange={(e) => setIssueDate(e.target.value)}
                    />
                  </div>

                  <div className="col">
                    <label className="form-label">Expiry Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={expiryDate}
                      onChange={(e) => setExpiryDate(e.target.value)}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Certification URL</label>
                  <input
                    type="url"
                    className="form-control"
                    value={certificationPath}
                    onChange={(e) => setCertificationPath(e.target.value)}
                  />
                </div>

                <div className="modal-footer px-0">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save Certification
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
